<template>
  <page :title="i18n.title">
    <div class="help-warp">
      <div class="help-body">
        <div class="help-items" >
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(0)">
              <span class="titleShow" v-if="activeIndex === 0">
                {{i18n.key1}}
              </span>
              <span class="title" v-else >
                {{i18n.key1}}
              </span>
              </div>
              <div class="collapse-item-body" v-if="activeIndex === 0">
                {{i18n.value1}}
              </div>
            </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(1)">
              <span class="titleShow" v-if="activeIndex === 1">
                {{i18n.key2}}
              </span>
              <span class="title" v-else >
                {{i18n.key2}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 1">
              {{i18n.value2}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(2)">
                <span class="titleShow" v-if="activeIndex === 2">
                  {{i18n.key3}}
                </span>
                <span class="title" v-else >
                  {{i18n.key3}}
                </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 2">
              {{i18n.value3_1}}<br>
              {{i18n.value3_2}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(3)">
              <span class="titleShow" v-if="activeIndex === 3">
                {{i18n.key4}}
              </span>
              <span class="title" v-else >
                {{i18n.key4}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 3">
              {{i18n.value4}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(4)">
              <span class="titleShow" v-if="activeIndex === 4">
               {{i18n.key5}}
              </span>
              <span class="title" v-else >
                {{i18n.key5}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 4">
              {{i18n.value5}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(5)">
              <span class="titleShow" v-if="activeIndex === 5">
                {{i18n.key6}}
              </span>
              <span class="title" v-else >
                {{i18n.key6}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 5">
              {{i18n.value6}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(6)">
              <span class="titleShow" v-if="activeIndex === 6">
                {{i18n.key7}}
              </span>
              <span class="title" v-else >
                {{i18n.key7}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 6">
              {{i18n.value7}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(7)">
              <span class="titleShow" v-if="activeIndex === 7">
                {{i18n.key8}}
              </span>
              <span class="title" v-else >
                {{i18n.key8}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 7">
              {{i18n.value8}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(8)">
              <span class="titleShow" v-if="activeIndex === 8">
                {{i18n.key9}}
              </span>
              <span class="title" v-else >
                {{i18n.key9}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 8">
              {{i18n.value9}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(9)">
              <span class="titleShow" v-if="activeIndex === 9">
                {{i18n.key10}}
              </span>
              <span class="title" v-else >
                {{i18n.key10}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 9">
              {{i18n.value10}}
            </div>
          </div>
          <div class="collapse-item-warp">
            <div class="collapse-item-head"  @click="onChange(10)">
              <span class="titleShow" v-if="activeIndex === 10">
                {{i18n.key11}}
              </span>
              <span class="title" v-else >
                {{i18n.key11}}
              </span>
            </div>
            <div class="collapse-item-body" v-if="activeIndex === 10">
              {{i18n.value11}}
            </div>
          </div>
        </div>
        <div class="ps">
          {{i18n.ps}}
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import { HELP_LIST } from '../../apis/user.js'
export default {
  components: {
  },
  computed: {
    i18n () {
      return this.$t('help')
    }
  },
  data () {
    return {
      activeIndex: 0,
      loading: false,
      error: '',
      items: []
    }
  },
  methods: {
    onChange (i) {
      this.activeIndex = i
    }

  },
  created () {
  }
}
</script>

<style>
.help-warp{
  height: 100%;
  position: relative;
}
.help-head{
  position: fixed;
  width: 100%;
  z-index: 998;
  background: rgba(249,249,249,1);
  /* #ifdef H5 */
  top: 88upx;
  /* #endif */
  /* #ifndef H5 */
  top: var(--window-top);
  /* #endif */
}
.help-body{
  position: absolute;
  /* top: 92upx; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #FFFFFF;
}
.help-items text{
  font-size: 28upx;
  font-weight: 400;
}
.collapse-item-warp{
  background: #FFFFFF;
  border: 1px solid rgba(217,217,217,1);
  margin: 10px;
  border-radius: 10px;
}
.collapse-item-warp+.collapse-item-warp{
  border-top: 1px solid rgba(217,217,217,1);
}
.collapse-item-head{
  display: flex;
  align-items: center;
  padding: 30px 34px;
  font-size: 32px;
}
.collapse-item-head span{
  flex: 1;
}
.collapse-item-head:after{
  content: '';
  display: inline-block;
  margin: 10px 0 0 0;
  width: 20px;
  height: 20px;
  border-top: 4px solid #CCCCCC;
  border-right: 4px solid #CCCCCC;
  transform: rotate(135deg);
  transition: transform 0.5s;
}
.collapse-item-head.active:after{
  transform: rotate(135deg);
  margin: 0px 0px 10px;
}
.collapse-item-body{
  padding: 16px 40px;
  font-family: MyFont4;
  font-weight: 700;
  font-size: 24px;
  color: #000000;
}
.title {
  padding-right: 20px;
  font-family: MyFont3;
  font-weight: 900;
  font-size: 28px;
  color: #000000;
}
.titleShow{
  padding-right: 20px;
  font-family: MyFont3;
  font-weight: 900;
  font-size: 28px;
  color: #036EB8;
}
.ps{
  text-align: center;
  margin-top: 25px;
  font-family: MyFont3;
  font-size: 24px;
  color: #036EB8;
}
</style>
